module.exports = __webpack_public_path__ + "static/002overlay-ea9184b3df5e086c6ec634b5804da3f3.png";